define('views/user/register/financial/questionsandanswers',[
    "backbone",
    "text!views/user/register/financial/questionsandanswers.html",
    "views/_base/baseview",
    "models/shared/qanda/questionandanswers",       
    "models/shared/qanda/questionsandanswersres",
    "views/user/register/financial/success",
    "views/user/register/financial/visaredirect",
    "views/user/register/financial/failure",
    "views/user/register/financial/productselection"
], function (Backbone, Template, BaseView, QandA, QandRes, SuccessView, VisaRedirect, FailureView, LoginManagementView, ProductSelectionView) {
    "use strict";

    return BaseView.extend({
        template : _.template(Template),
        tagName  : "section",
        id       : "outOfWallet",
        isRender : false,
        needsAuth: true,
        activityIndicator: false,
        model    : null,
        events   : {          
            "click .js-continue": "continueQA"
        },
        initialize: function (options) {
            options = options || {};
            if (options.qamodel == undefined)
                this.model = options.model;
            else
                this.model = options.qamodel;
            this.usermodel = options.umodel;
            this.Message = options.Message;
            this.product = options.product;
            this.header = "We need some additional information";
            this.explain = "We're having trouble verifying your identity. Please answer these quick questions to help us resolve this issue.";

            this.applicantAge = options.applicantAge;
            this.userGUID = options.userGUID;
            this.user = options.user;
            this.CompanionAccess = options.CompanionAccess;
            this.elementName = options.elementName;
            this.data = this.model;
            this.triggerRoute = getCipTriggerRoute();
            BaseView.prototype.initialize(this);
            this.render();
        },
        render: function () {                      
            this.$el.html(this.template({ this: this.model }));          
            this.delegateEvents();
            return this;
        },
        linkVisa: function (e) {
            var visaRedirectView = new VisaRedirect({ elementName: "#mainRegion" });
            pf.show(visaRedirectView);
        },
        continueQA: function (e) {
            if (e && e.preventDefault) { e.preventDefault(); }
            if (e && e.stopPropagation) { e.stopPropagation(); }
            this.$(".js-continue").addClass("btn-showSpinner");

            var that = this;
            this.newmodel = new QandRes({
                instanceURL: pf.consumerURL + "/OutOfWallet"
            });
            this.newmodel.cardType = this.product;
            this.newmodel.transactionID = this.model.TID;
            this.newmodel.questionSetID = this.model.QSID;
            this.newmodel.questionID1 = this.model.MQ[0].QID;
            this.newmodel.howManyRouts = this.model.HMR;
            this.newmodel.CIPResultID = this.model.CIPRID;
            this.newmodel.choiceID1 = this.$('input[name=questio1choises]:checked').val();
            if (this.model.MQ[1] != undefined) {
                this.newmodel.questionID2 = this.model.MQ[1].QID;
                this.newmodel.choiceID2 = this.$('input[name=questio2choises]:checked').val();
            }
            if (this.model.MQ[2] != undefined) {
                this.newmodel.questionID3 = this.model.MQ[2].QID;
                this.newmodel.choiceID3 = this.$('input[name=questio3choises]:checked').val();
            }

            this.newmodel.SSN4 = this.usermodel.SSN4;
            if (this.usermodel.E == undefined)
                this.newmodel.Email = this.usermodel.Email;
            else
                this.newmodel.Email = this.usermodel.E;
            if (this.usermodel.FN == undefined)
                this.newmodel.FirstName = this.usermodel.FirstName;
            else
                this.newmodel.FirstName = this.usermodel.FN;
            if (this.usermodel.LN == undefined)
                this.newmodel.LastName = this.usermodel.LastName;
            else
                this.newmodel.LastName = this.usermodel.LN;
            if (this.usermodel.A1 == undefined)
                this.newmodel.AddressLine1 = this.usermodel.AddressLine1;
            else
                this.newmodel.AddressLine1 = this.usermodel.A1;
            if (this.usermodel.A2 == undefined)
                this.newmodel.AddressLine2 = this.usermodel.AddressLine2;   
            else
                this.newmodel.AddressLine2 = this.usermodel.A2;
            if (this.usermodel.Z == undefined)
                this.newmodel.Zip = this.usermodel.Zip;
            else
                this.newmodel.Zip = this.usermodel.Z;
            if (this.usermodel.ZID == undefined)
                this.newmodel.ZipID = this.usermodel.ZipID;
            else
                this.newmodel.ZipID = this.usermodel.ZID;
            if (this.usermodel.C == undefined)
                this.newmodel.City = this.usermodel.City;
            else
                this.newmodel.City = this.usermodel.C;
            if (this.usermodel.PH == undefined)
                this.newmodel.Phone = this.usermodel.Phone;
            else
                this.newmodel.Phone = this.usermodel.PH;
            if (this.usermodel.S == undefined)
                this.newmodel.State = this.usermodel.State;
            else
                this.newmodel.State = this.usermodel.S;
            if (this.usermodel.SA == undefined)
                this.newmodel.StateAbr = this.usermodel.StateAbr;
            else
                this.newmodel.StateAbr = this.usermodel.SA;
            if (this.usermodel.STID == undefined)
                this.newmodel.StateID = this.usermodel.StateID;
            else
                this.newmodel.StateID = this.usermodel.STID;
            this.newmodel.DOB = this.usermodel.DOB;
            if (this.usermodel.UG == undefined)
                this.newmodel.UserGUID = this.usermodel.UserGUID;
            else
                this.newmodel.UserGUID = this.usermodel.UG;
            if (this.usermodel.SMS == undefined)
                this.newmodel.SMS = this.usermodel.SMS;
            else
                this.newmodel.SMS = this.usermodel.SMS;
            if (this.usermodel.OIWP == undefined)
                this.newmodel.OIWP = this.usermodel.OIWP;
            else
                this.newmodel.OIWP = this.usermodel.OIWP;
            
            this.newmodel.save(null, {
                url: pf.consumerURL + "/OutOfWallet",
                success: function (newmodel, resp) {
                    if(resp.QandA.TR == "questions"){
                        that.model = resp.QandA;
                        that.Message = resp.QandA.TT;
                        that.product = that.product;
                        that.umodel = that.newmodel;
                        that.initialize(that);
                    } else {
                        store.setStoreItem(enums.modelsEnum.IsRegistration, { Data: 0 });
                        if (resp.QandA.TR == "passed" && (resp.QandA.AGID || that.product == enums.cardTypes.ZCard)) {
                            pf.session.getAuth(function () { });
                            if(that.triggerRoute){
                                // pf.navigate(that.triggerRoute);
                                // removeCipTriggerRoute();
                                window.location.href = 'wallet';
                                removeCipTriggerRoute();
                                window.location.reload();
                                return;
                            }
                            var productSelectionView = new ProductSelectionView({ elementName: "#mainRegion" });
                            pf.show(productSelectionView);
                        } else {
                            that.Message = resp.QandA.TR;
                            var failureView = new FailureView({ Message: that.Message, elementName: "#mainRegion" });
                            pf.show(failureView);
                        }

                        that.Message = resp.QandA.TT;
                        if (resp.QandA.TR == "failed") {
                            that.Message = resp.QandA.TR;
                            var failureView = new FailureView({ Message: that.Message,  elementName: "#mainRegion" });
                            pf.show(failureView);
                        }
                    }
                },
                error: function (model, resp) {
                    pfdialog.error({ context: this, Body: "Your request was not completed at this moment", Title: "Internal error" });
                }
            });
        },       
        close: function() {}
    });
});

